/* HOD · bande set : progression du slider d'etapes mobile (02_home.md §4, lot 3).
   <hod-steps> contient la rangee [data-hod-steps-rail] et les segments [data-hod-steps-seg].
   Formule proportionnelle (l'etape 3 reste atteinte sur grand mobile), defilement passif,
   throttle par horodatage 60 ms plus une mise a jour finale (Blueprint §7.10, sans rAF).
   Aucune ecriture en dehors des classes des segments ; rien a faire en desktop (rangee fixe). */
if (!customElements.get('hod-steps')) {
  class HodSteps extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-hod-steps-rail]');
      this.segs = Array.from(this.querySelectorAll('[data-hod-steps-seg]'));
      if (!this.rail || this.segs.length < 2) return;
      this.last = 0;
      this.timer = 0;
      this.current = 0;
      this.onScroll = () => {
        const now = Date.now();
        clearTimeout(this.timer);
        if (now - this.last >= 60) {
          this.last = now;
          this.update();
        }
        this.timer = setTimeout(() => this.update(), 80);
      };
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.rail && this.onScroll) this.rail.removeEventListener('scroll', this.onScroll);
    }

    update() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const n = this.segs.length - 1;
      const ratio = max > 0 ? Math.abs(this.rail.scrollLeft) / max : 0;
      const i = Math.min(n, Math.max(0, Math.round(ratio * n)));
      if (i === this.current && this.segs[i].classList.contains('is-active')) return;
      this.current = i;
      this.segs.forEach((seg, k) => seg.classList.toggle('is-active', k === i));
    }
  }
  customElements.define('hod-steps', HodSteps);
}
